import { jsx as _jsx } from 'react/jsx-runtime.js';
import { SocialLinkedInButton } from '@stepstone-genesis/components';
import { useEffect } from 'react';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../hooks.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../../core/sourceData/sourceDataSlice.js';
import { toRelativeUrl } from '../../../../helpers/url/url.js';
import { redirectToLinkedIn } from '../service/index.js';
import { redirectingStatusSelector, setIsRedirecting, } from '../loginWithLinkedInSlice.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
import { STORAGE_KEY_LOGIN_SOURCE, STORAGE_KEY_RETURN_URL, } from '../../../core/sourceData/safeInitSourceData.js';
import { API_URLS } from '../../../../configs/constants/urls.js';
// TODO: write some units for this component
export const LinkedInButtonComponent = ({ buttonText, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const redirectingStatus = useAppSelector(redirectingStatusSelector);
    const { trackBtnClick } = useTrack('linkedin');
    const loginSource = useAppSelector(loginSourceSelector) ||
        sessionStorage.getItem(STORAGE_KEY_LOGIN_SOURCE);
    const returnUrl = useAppSelector(redirectionUrlSelector) ||
        sessionStorage.getItem(STORAGE_KEY_RETURN_URL) ||
        '/';
    const isRedirecting = (status) => dispatch(setIsRedirecting(status));
    useEffect(() => {
        if (redirectingStatus) {
            dispatch(isRedirecting(false));
        }
    }, []);
    const relativeUrl = toRelativeUrl(returnUrl) || '/';
    const params = {
        loginSource,
        encodedReturnUrl: encodeURIComponent(relativeUrl),
    };
    const onSignIn = () => {
        trackBtnClick({ uniqueName: 'linkedin' });
        dispatch(isRedirecting(true));
        redirectToLinkedIn(params, API_URLS.BFF.LINKEDIN_REGISTER);
    };
    return (_jsx(SocialLinkedInButton, { "data-testid": "linkedin-login-btn", as: "button", a11yLabel: t('loginregistration.login.linkedInButton.a11yLabel'), type: "button", isLoading: redirectingStatus, isFullWidth: true, size: ['medium'], onClick: onSignIn, children: buttonText ?? t('loginregistration.login.linkedInButton') }));
};
//# sourceMappingURL=LinkedInButtonComponent.js.map